/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const itemFinancialsResponseSchema = z.object({
  capexPercentage: z.string().describe("CapEx percentage of this item's budget").nullish(),
  computedAt: z.iso
    .datetime()
    .describe(
      'When these financial values were last computed or updated. For items with a computed aggregate, this is when the rollup was last calculated; for items with only direct financial values (budget, CapEx%, forecast revenue) and no computed aggregate yet, this is when that direct value was last set.',
    ),
  descendantsBudgetAmount: z
    .string()
    .describe("Sum of this item's descendants' effective budgets")
    .nullish(),
  descendantsForecastRevenueAmount: z
    .string()
    .describe("Sum of this item's descendants' effective forecast revenues")
    .nullish(),
  effectiveBudget: z
    .string()
    .describe(
      "Effective budget: this item's own budget if set, otherwise the sum of its descendants' effective budgets",
    )
    .nullish(),
  effectiveForecastRevenue: z
    .string()
    .describe(
      "Effective forecast revenue: this item's own forecast revenue if set, otherwise the sum of its descendants' effective forecast revenues",
    )
    .nullish(),
  itemId: z.int().describe('Item id'),
  opexPercentage: z.string().describe("OpEx percentage of this item's budget").nullish(),
  rolledActualCost: z.string().describe('Actual cost for this item and its descendants').nullish(),
  rolledActualCostStatus: z
    .enum(['COMPLETE', 'INCOMPLETE', 'PRESERVED', 'UNAVAILABLE'])
    .describe(
      'Completeness of rolledActualCost, reflecting this item and all descendants. Same semantics as selfActualCostStatus.',
    )
    .nullish(),
  selfActualCost: z.string().describe('Actual cost for this item only').nullish(),
  selfActualCostStatus: z
    .enum(['COMPLETE', 'INCOMPLETE', 'PRESERVED', 'UNAVAILABLE'])
    .describe(
      'Completeness of selfActualCost: COMPLETE (trustworthy, including a valid zero), INCOMPLETE (computed but some inputs were missing), PRESERVED (a prior value, not freshly computed), or UNAVAILABLE (no value could be computed or preserved). Null for items predating this field.',
    )
    .nullish(),
  selfBudgetAmount: z.string().describe('Budget for this item only').nullish(),
  selfForecastRevenueAmount: z.string().describe('Forecast revenue for this item only').nullish(),
});
